// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Trash = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Trash = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Trash = _exports.Trash = function Trash(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14586)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.51147 3.39844H11.4854C11.571 3.39844 11.6504 3.4397 11.698 3.5127L12.301 4.41406H7.69897L8.302 3.5127C8.34961 3.44287 8.42896 3.39844 8.51465 3.39844H8.51147ZM14.1323 4.41406L12.9675 2.66528C12.6375 2.17334 12.082 1.875 11.4885 1.875H8.51147C7.91797 1.875 7.36255 2.17334 7.03247 2.66528L5.86768 4.41406H5.43286H3.90625H3.65234C3.23022 4.41406 2.89062 4.75366 2.89062 5.17578C2.89062 5.5979 3.23022 5.9375 3.65234 5.9375H4.02051L4.78223 16.2429C4.86157 17.303 5.7439 18.125 6.80713 18.125H13.1897C14.2529 18.125 15.1353 17.303 15.2146 16.2429L15.9795 5.9375H16.3477C16.7698 5.9375 17.1094 5.5979 17.1094 5.17578C17.1094 4.75366 16.7698 4.41406 16.3477 4.41406H16.0938H14.5671H14.1323ZM14.4529 5.9375L13.6975 16.1318C13.6785 16.3984 13.4563 16.6016 13.1897 16.6016H6.80713C6.54053 16.6016 6.32153 16.3953 6.29932 16.1318L5.54712 5.9375H14.4529Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14586"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "16.25",
      height: "16.25",
      fill: "currentColor",
      transform: "translate(1.875 1.875)"
    }))));
  };
});
